/**
 * FAQ accordion
 */

var faq_accordion_toggle = function(e) {
  e.stopPropagation();
  var plus = e.currentTarget.parentNode.querySelector('.title .icon-plus');
  var minus = e.currentTarget.parentNode.querySelector('.title .icon-minus');
  var target = e.currentTarget.parentNode.querySelector('.content');
  target.classList.toggle("open");
  plus.classList.toggle("hide");
  minus.classList.toggle("show");
};

var faq_accordion_init = function() {
  var faqs = document.querySelectorAll('.faq__question .title');
  faqs.forEach(item => {
    let button = item;
    button.addEventListener('click', faq_accordion_toggle, false);
  });
};

faq_accordion_init();

//faq-page
var faq_accordion_toggle = function(e) {
  e.stopPropagation();
  e.preventDefault();
  var plus = e.currentTarget.parentNode.querySelector('.faq-container__question--title .icon-plus');
  var minus = e.currentTarget.parentNode.querySelector('.faq-container__question--title .icon-minus');
  var target = e.currentTarget.parentNode.querySelector('.faq-container__question--answer');
  target.classList.toggle("show");
  plus.classList.toggle("hide");
  minus.classList.toggle("show");
};

var faq_accordion_init = function() {
  var faqs = document.querySelectorAll('.faq-container__question--title');
  faqs.forEach(item => {
    let button = item;
    button.addEventListener('click', faq_accordion_toggle, false);
  });
};

faq_accordion_init();


/**
 * FAQ filter
 */
 var maston_faq_filter = function() {


  /**
   * Filter items
   */

  var filter = document.getElementById('js-faq-filter');
  var items = document.querySelectorAll('.js-faq-item');

  if (filter) {
    var input_change = new Event('input');

    var search = filter.querySelector('.js-faq-filter-input');

    // listen to input events
    search.addEventListener('input', function(){

      // filter items with content matching current input value
      for (var i = 0; i < items.length; ++i) {
        if (items[i].innerHTML.toUpperCase().indexOf(this.value.toUpperCase()) > -1) {
          items[i].classList.add('show');
        } else {
          items[i].classList.remove('show');
        }
      }
    });

    /**
     * Search suggestions
     */

    var suggestions = document.getElementById('js-faq-suggestions');

    var suggestion_to_input = function() {
      search.value = this.getAttribute('data-suggestion');
      search.dispatchEvent(input_change);
    };

    if (suggestions) {
      var suggestion = suggestions.querySelectorAll('.js-faq-suggestion');

      for (var s = 0; s < suggestion.length; ++s) {
        suggestion[s].addEventListener('click', suggestion_to_input, false);
      }
    }
  }

};

maston_faq_filter();
